module.exports = __webpack_public_path__ + "img/bbd8a30.jpg";